<template>
  <SpForm ref="hrForm" @validation="validation" @submit="submit">
    <SpInput v-show="false" v-model="personal.id"
             name="id"
             style="margin-top: 4px" placeholder="English" row="3" height="40" required type="warn2" />
    <div class="content-form flex-jc-start">
      <div class="flex-1">
        <div class="flex-al-center flex-jc-start">
          <div class="pd-r-10 right text-right">
            <SpSelect v-model="personal.title"
                      name="title"
                      :type="nameInputDisable ? 'gray' : 'warn'"
                      :disabled="nameInputDisable"
                      required
                      :show-clear="false" class="" :need-search="false"
                      style=" float: right" height="40">
              <SpSelectOption v-for="app in appellations" :key="app" :label="app" :value="app" />
            </SpSelect>
          </div>
          <div class="flex-1" style="position: relative">
            <span class="fn-span font16 italic">Full Name</span>
            <SpInput v-model="personal.fullName"
                     name="fullName"
                     :type="nameInputDisable ? 'gray' : 'warn'"
                     :disabled="nameInputDisable"
                     :validate-reg="/^(?=.*[A-Za-z])[A-Za-z ]{3,64}$/"
                     placeholder="English" row="3" height="40" required />
          </div>
          <div class="icon-panel">
            <span v-if="personal.id && personal.id.toString().includes('v') > 0" style="cursor: not-allowed" class="icon-edit-1 iconfont" />
            <span v-else class="icon-edit-1 iconfont" @click="nameChangedDis" />
          </div>
        </div>

        <div class="flex-al-center flex-jc-start">
          <div class="pd-r-10 right text-right" />
          <div class="flex-1" style="position: relative">
            <SpInput v-model="personal.fullNameNative"
                     name="fullNameNative"
                     :type="nameInputDisable ? 'gray' : 'warn2'"
                     :disabled="nameInputDisable"
                     :validate-reg="/^.{2,64}$/"
                     style="margin-top: 4px" placeholder="Native Name" row="3" height="40" />
          </div>
          <div class="icon-panel" />
        </div>

        <div class="flex-al-center flex-jc-start">
          <div class="pd-r-10 right text-right" />
          <div class="flex-1" style="position: relative">
            <p class="font14 italic mg-t-30 sp-color-7">The unique password I set for him/her ASF:</p>
          </div>
          <div class="icon-panel" />
        </div>

        <div class="flex-al-center flex-jc-start">
          <div class="pd-r-10 right text-right" />
          <div class="flex-1" style="position: relative">
            <div class="flex-al-center flex-jc-start">
              <div style="width:120px; padding-right: 2px;" class="font14 italic sp-color-7 text-right">
                {{ $l('hrPwd') }}
              </div>
              <div class="flex-1">
                <SpInput v-if="personal.id && personal.id.toString().includes('v') < 0 " v-model="personal.password"
                         required
                         name="password"
                         :validate-reg="/^[A-Za-z0-9~!@#$%^&*()\-+=:;,._]{4,18}$/"
                         :type="pwdInputDisable ? 'gray' : 'warn'"
                         :disabled="pwdInputDisable"
                         password
                         style="margin-top: 4px" row="3" height="40" />
                <SpInput v-else v-model="personal.password"
                         name="password" password
                         :validate-reg="/^[A-Za-z0-9~!@#$%^&*()\-+=:;,._]{4,18}$/"
                         :type="pwdInputDisable ? 'gray' : 'warn'"
                         :disabled="pwdInputDisable"
                         style="margin-top: 4px" row="3" height="40" />
              </div>
            </div>
          </div>
          <div class="icon-panel">
            <span v-if="personal.id && personal.id.toString().includes('v') > 0" style="cursor: not-allowed" class="icon-edit-1 iconfont" />
            <span v-else class="icon-edit-1 iconfont" @click="pwdChangedDis" />
          </div>
        </div>
        <div class="flex-al-center flex-jc-start">
          <div class="pd-r-10 right text-right" />
          <div class="flex-1" style="position: relative">
            <div class="flex-al-center flex-jc-start">
              <div style="width:120px; padding-right: 2px;" class="font14 italic sp-color-7 text-right">
                {{ $l('hrRePwd') }}
              </div>
              <div class="flex-1">
                <SpInput v-if="personal.id && personal.id.toString().includes('v') < 0" v-model="personal.passwordConfirmation"
                         password
                         :validate-reg="/^[A-Za-z0-9~!@#$%^&*()\-+=:;,._]{4,18}$/"
                         name="passwordConfirmation"
                         :type="pwdInputDisable ? 'gray' : 'warn'"
                         :disabled="pwdInputDisable"
                         style="margin-top: 4px" row="3" height="40" required />
                <SpInput v-else v-model="personal.passwordConfirmation"
                         name="passwordConfirmation" password
                         :validate-reg="/^[A-Za-z0-9~!@#$%^&*()\-+=:;,._]{4,18}$/"
                         :type="pwdInputDisable ? 'gray' : 'warn'"
                         :disabled="pwdInputDisable"
                         style="margin-top: 4px" row="3" height="40" />
              </div>
            </div>
          </div>
          <div class="icon-panel" />
        </div>
      </div>
      <div style="width: 305px" class="avatar-panel pd-l-30">
        <div class="avatar-select">
          <p class="font16 italic name-label sp-color-18">{{ $l('HeadPortrait') }}</p>
          <sp-upload-group ref="avatarUpload" v-model="personal.avatar" max-count="1" width="198"
                           :default-files="personal.avatar"
                           height="240"
                           file-type="user/avatar"
                           name="avatar"
                           class="avatar-uploader" action="#" :show-file-list="false"
                           list-type="picture-card"
                           :upload-after-select="false" @afterSelect="afterSelect" />
        </div>
      </div>
    </div>
  </SpForm>
</template>

<script>
import { computed, ref, watch } from 'vue'
import SpForm from '@/components/common/SpForm'
import SpInput from '@/components/common/SpInput'
import SpSelect from '@/components/common/SpSelect'
import SpSelectOption from '@/components/common/SpSelectOption'
import spUploadGroup from '@/components/common/SpUploadGroup'
import SpMessage from '@/components/common/SpMessage'
import { getUserTitle } from '@/request/APIs/common'
import _cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'HrForm',
  nameSpace: 'hr',
  components: {
    SpInput,
    SpSelect,
    SpSelectOption,
    spUploadGroup,
    SpForm
  },

  props: {
    modelValue: {
      type: Object,
      default: () => {
      }
    },

    personalIndex: {
      type: Number,
      default: null
    }
  },

  emits: ['addPerson'],
  setup (props, ctx) {
    const hrForm = ref(null)
    const personal = computed({
      get () {
        return props.modelValue
      },
      set (nv) {
        ctx.emit('update:modelValue', nv)
      }
    })

    // 表单提交颜值
    const addPerson = () => {
      hrForm.value.beforeSubmit()
    }
    // 验证表单
    const validationForm = () => {
      hrForm.value.beforeSubmitOnlyValidation()
    }

    const submit = (formData, form) => {
      if (!formData.validate) {
        SpMessage.error('There is some error in the form list!')
      } else {
        const p = _cloneDeep(personal)
        hrForm.value.clearForm()
        ctx.emit('addPerson', p, props.personalIndex)
      }
    }
    const validation = (formData, form) => {
      if (!formData.validate) {
        SpMessage.error('There is some error in the form list!')
      } else {
        ctx.emit('comfirmSubt')
      }
    }
    const appellations = ref([])
    // 获取称谓
    getUserTitle().then(res => {
      appellations.value = res.data
    })
    const afterSelect = (files) => {
    }
    const clearForm = () => {
      const p = _cloneDeep(personal)
      hrForm.value.clearForm()
      return { p, index: props.personalIndex }
    }
    // name 输入框是否锁定
    const nameInputDisable = ref(false)
    // password 输入框是否锁定
    const pwdInputDisable = ref(false)
    watch(() => personal.value.id, (n) => {
      if (n && !n.toString().includes('v')) {
        nameInputDisable.value = true
        pwdInputDisable.value = true
      } else {
        nameInputDisable.value = false
        pwdInputDisable.value = false
      }
    })
    const nameChangedDis = () => {
      nameInputDisable.value = !nameInputDisable.value
    }
    const pwdChangedDis = () => {
      pwdInputDisable.value = !pwdInputDisable.value
    }

    return {
      addPerson,
      hrForm,
      personal,
      appellations,
      nameInputDisable,
      pwdInputDisable,
      submit,
      afterSelect,
      clearForm,
      nameChangedDis,
      pwdChangedDis,
      validation,
      validationForm
    }
  }

}
</script>

<style scoped lang="less">
.icon-panel {
  padding-left: 10px;
  .iconfont {
    font-size: 22px;
  }
}
.fn-span{
  position: absolute;
  top: -14px;
  color: #000000;
  opacity: 0.8;
}
.content-form{
  width: 800px;
  .right{
    width: 139px;
  }
  .icon-panel{
    width: 32px;
    box-sizing: border-box;
  }
}
.avatar-panel {
  position: relative;
  top: -14px;
  .name-label {
    margin: 0;
  }
  .avatar-uploader{
    width: 198px;
    height: 240px;
    position: absolute;
    top: 14px;
  }
}
</style>
